export class WeeklyConfig {
    'daysOfWeek';
    'timeOfDay';
    'startWindowMinutes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "daysOfWeek",
            "baseName": "daysOfWeek",
            "type": "Set<DayOfWeek>",
            "format": ""
        },
        {
            "name": "timeOfDay",
            "baseName": "timeOfDay",
            "type": "TimeOfDay",
            "format": ""
        },
        {
            "name": "startWindowMinutes",
            "baseName": "startWindowMinutes",
            "type": "number",
            "format": "long"
        }
    ];
    static getAttributeTypeMap() {
        return WeeklyConfig.attributeTypeMap;
    }
    constructor() {
    }
}
